import React from "react";
import styled from "styled-components";

import { BrandPanel } from "../../../../common/brand-panel";
import { UIConstants } from "../../../../styles/uiConstants";

const EnrollmentLayout: React.FC<{
  children: React.ReactNode;
  centered?: boolean;
}> = ({ children, centered }) => (
  <Page>
    <StickyBrandPanel />
    <RightPanel $isCentered={centered}>{children}</RightPanel>
  </Page>
);

export default EnrollmentLayout;

const Page = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;

  @media (max-width: ${UIConstants.TABLET_BREAKPOINT}px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

/** The form scrolls on its own; the pitch stays in view beside it. */
const StickyBrandPanel = styled(BrandPanel)`
  position: sticky;
  top: 0;
  height: 100vh;

  @media (max-width: ${UIConstants.TABLET_BREAKPOINT}px) {
    position: static;
    height: auto;
  }
`;

const RightPanel = styled.div<{ $isCentered?: boolean }>`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: ${(props) => (props.$isCentered ? "center" : "stretch")};
  padding: 24px 40px 48px;

  @media (max-width: ${UIConstants.TABLET_BREAKPOINT}px) {
    padding: 20px;
  }
`;
